// import React, { useState } from "react";
// import "./FileUpload.css";
// import {
//   Search,
//   Download,
//   Trash2,
//   Upload,
//   User,
//   SlidersHorizontal,
//   ArrowUpDown,
//   Eye,
//   FileText,
//   AlertCircle,
//   CheckCircle,
//   Filter,
//   Grid,
//   List,
//   Calendar,
//   HardDrive,
//   X,
// } from "lucide-react";
// const FileUpload = ({
//   onFileUploaded,
//   onUploadProgress,
//   onUploadError,
//   accessToken,
//   disabled,
// }) => {
//   const [uploading, setUploading] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [dragOver, setDragOver] = useState(false);

//   const supportedFormats = [
//     ".dwg",
//     ".dwf",
//     ".dwfx",
//     ".ifc",
//     ".rvt",
//     ".nwd",
//     ".nwc",
//     ".3ds",
//     ".fbx",
//     ".obj",
//     ".step",
//     ".stp",
//     ".iges",
//     ".igs",
//     ".sat",
//     ".sab",
//     ".skp",
//     ".3dm",
//     ".stl",
//     ".max",
//     ".bimx",
//   ];

//   const handleFileSelect = (files) => {
//     if (!files || files.length === 0) return;

//     const file = files[0];

//     // Check file format
//     const extension = "." + file.name.split(".").pop().toLowerCase();
//     if (!supportedFormats.includes(extension)) {
//       onUploadError?.(`Unsupported file format: ${extension}`);
//       return;
//     }

//     // Check file size (100MB limit)
//     const maxSize = 400 * 1024 * 1024; // 100MB
//     if (file.size > maxSize) {
//       onUploadError?.("File size exceeds 100MB limit");
//       return;
//     }

//     uploadFile(file);
//   };

//   const uploadFile = async (file) => {
//     if (!accessToken) {
//       onUploadError?.("Access token required for file upload");
//       return;
//     }

//     setUploading(true);
//     setProgress(0);

//     try {
//       const FileUploadService = (
//         await import("../../services/FileUploadService")
//       ).default;

//       const result = await FileUploadService.uploadFile(
//         file,
//         accessToken,
//         (progressPercent) => {
//           setProgress(progressPercent);
//           onUploadProgress?.(progressPercent);
//         }
//       );

//       setUploading(false);
//       onFileUploaded?.(result);
//     } catch (error) {
//       setUploading(false);
//       setProgress(0);
//       onUploadError?.(error.message);
//     }
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setDragOver(false);
//     handleFileSelect(e.dataTransfer.files);
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     setDragOver(true);
//   };

//   const handleDragLeave = (e) => {
//     e.preventDefault();
//     setDragOver(false);
//   };

//   return (
//     <div className="file-upload">
//       <div
//         className={`upload-area ${dragOver ? "drag-over" : ""} ${
//           uploading ? "uploading" : ""
//         }`}
//         onDrop={handleDrop}
//         onDragOver={handleDragOver}
//         onDragLeave={handleDragLeave}
//         onClick={() =>
//           !disabled &&
//           !uploading &&
//           document.getElementById("file-input").click()
//         }
//       >
//         <input
//           id="file-input"
//           type="file"
//           style={{ display: "none" }}
//           accept={supportedFormats.join(",")}
//           onChange={(e) => handleFileSelect(e.target.files)}
//           disabled={disabled || uploading}
//         />
//         <div className="upload-progress"></div>
//         <div className="upload-placeholder">
//           <button className="uploadHeaderBtn">
//             <Upload size={18} />
//             Upload File
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FileUpload;
import React, { useState } from "react";
import "./FileUpload.css";
import { Upload } from "lucide-react";

const FileUpload = ({
  onFileUploaded,
  onUploadProgress,
  onUploadError,
  accessToken,
  disabled,
}) => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [dragOver, setDragOver] = useState(false);

  const supportedFormats = [
    ".dwg",
    ".dwf",
    ".dwfx",
    ".ifc",
    ".rvt",
    ".nwd",
    ".nwc",
    ".3ds",
    ".fbx",
    ".obj",
    ".step",
    ".stp",
    ".iges",
    ".igs",
    ".sat",
    ".sab",
    ".skp",
    ".3dm",
    ".stl",
    ".max",
    ".bimx",
  ];

  const handleFileSelect = (files) => {
    console.log("[FileUpload] handleFileSelect called, files:", files);

    if (!files || files.length === 0) {
      console.log("[FileUpload] No files provided, aborting");
      return;
    }

    const file = files[0];
    console.log("[FileUpload] Selected file:", file.name, file.size, "bytes");

    // Check file format
    const extension = "." + file.name.split(".").pop().toLowerCase();
    if (!supportedFormats.includes(extension)) {
      console.log("[FileUpload] Unsupported format:", extension);
      onUploadError?.(`Unsupported file format: ${extension}`);
      return;
    }

    // Check file size (100MB limit)
    const maxSize = 400 * 1024 * 1024; // 100MB
    if (file.size > maxSize) {
      console.log("[FileUpload] File too large:", file.size);
      onUploadError?.("File size exceeds 100MB limit");
      return;
    }

    console.log("[FileUpload] Validation passed, calling uploadFile()");
    uploadFile(file);
  };

  const uploadFile = async (file) => {
    console.log(
      "[FileUpload] uploadFile() started. accessToken present?",
      !!accessToken,
    );

    if (!accessToken) {
      console.log(
        "[FileUpload] NO ACCESS TOKEN — aborting upload, calling onUploadError",
      );
      onUploadError?.("Access token required for file upload");
      return;
    }

    setUploading(true);
    setProgress(0);

    console.log(
      "[FileUpload] Calling onUploadProgress(0) immediately. typeof onUploadProgress:",
      typeof onUploadProgress,
    );
    // ԿԱՐԵՎՈՐ ՈՒՂՂՈՒՄ. ծանուցում ենք parent-ին ԱՆՄԻՋԱՊԵՍ (0%):
    onUploadProgress?.(0);

    try {
      console.log("[FileUpload] Dynamically importing FileUploadService...");
      const FileUploadService = (
        await import("../../services/FileUploadService")
      ).default;
      console.log(
        "[FileUpload] FileUploadService imported:",
        FileUploadService,
      );

      const result = await FileUploadService.uploadFile(
        file,
        accessToken,
        (progressPercent) => {
          console.log(
            "[FileUpload] progress callback fired with:",
            progressPercent,
          );
          setProgress(progressPercent);
          onUploadProgress?.(progressPercent);
        },
      );

      console.log("[FileUpload] Upload finished successfully. Result:", result);
      setUploading(false);
      onFileUploaded?.(result);
    } catch (error) {
      console.error("[FileUpload] Upload FAILED:", error);
      setUploading(false);
      setProgress(0);
      onUploadError?.(error.message);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    console.log("[FileUpload] onDrop fired");
    handleFileSelect(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  return (
    <div className="file-upload">
      <div
        className={`upload-area ${dragOver ? "drag-over" : ""} ${
          uploading ? "uploading" : ""
        }`}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onClick={() => {
          console.log(
            "[FileUpload] upload area clicked. disabled?",
            disabled,
            "uploading?",
            uploading,
          );
          !disabled &&
            !uploading &&
            document.getElementById("file-input").click();
        }}
      >
        <input
          id="file-input"
          type="file"
          style={{ display: "none" }}
          accept={supportedFormats.join(",")}
          onChange={(e) => {
            console.log("[FileUpload] file input onChange fired");
            handleFileSelect(e.target.files);
          }}
          disabled={disabled || uploading}
        />
        <div className="upload-progress"></div>
        <div className="upload-placeholder">
          <button className="uploadHeaderBtn">
            <Upload size={18} />
            Upload File
          </button>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
